import { QueryHookOptions, useQuery } from '@apollo/react-hooks'
import { PROPERTY_QUERY } from 'apollo'

export const usePropertyQuery = (options: QueryHookOptions<any, any> = {}) => useQuery(PROPERTY_QUERY, options)
